<script>
	import Lotto from "./contract-stores.js";
	import {
		connected,
		web3,
		selectedAccount,
		defaultChainStore,
	} from "svelte-web3";
	import '../node_modules/bulma/css/bulma.css';
	import { fade } from "svelte/transition";

	let owner;
	const waiting = "Waiting for connection..."
	//for 'load more'
	let currentItems = 5;

	async function getPastWinners() {
		let winners = await $Lotto.getPastEvents("JackpotWon", {
			fromBlock: 0,
			toBlock: "latest",
		});
		return winners.reverse();
	}
	async function getJackpot() {
		let jackpot = await $Lotto.methods.getJackpot().call();
		return $web3.utils.fromWei(jackpot, "ether");
	}
	async function playLotto() {
		await $Lotto.methods.playLotto().send({
			from: $selectedAccount,
			value: "100000000000000000",
			gas: "550000",
		});
		await updateStats();
	}
	async function getWinner() {
		await $Lotto.methods
			.getWinner()
			.send({ from: $selectedAccount, gas: "5500000" })
			.then(console.log("Get winner initialized"));
		await updateStats();
	}
	async function payWinner() {
		await $Lotto.methods
			.payWinner()
			.send({ from: $selectedAccount, gas: "550000" })
			.then(console.log("Pay winner initialized"));
		await updateStats();
	}
	async function getGameNo() {
		let gameNo = await $Lotto.methods.gameNo().call();
		return gameNo;
	}

	async function getPlayers() {
		let players = await $Lotto.methods.getPlayers().call();
		return players;
	}

	async function get0wner() {
		owner = await $Lotto.methods.owner().call();
		owner = owner.toLowerCase()
		if (owner == $selectedAccount) {
			return owner;
		} else {
			return false;
		}
	}

	$: jackpot = $Lotto ? getJackpot() : "";
	$: gameNo  = $Lotto ? getGameNo() : "";
	$: players = $Lotto ? getPlayers() : "";
	$: winners = $Lotto ? getPastWinners() : "";
	$: owner   = $Lotto ? get0wner() : "";

	async function updateStats() {
		jackpot	 = await getJackpot();
		gameNo	 = await getGameNo();
		players	 = await getPlayers();
		winners	 = await getPastWinners();
	}
</script>

<main>
	<nav class="navbar pt-5 has-background-light is-spaced is-flex is-shadow">
		<div class="container mb-3-mobile">
			<div class="navbar-brand is-size-4-desktop is-size-3-mobile has-text-centered-mobile is-justify-content-center">
				<h2>Ether Lotto</h2>
			</div>

			<div class="navbar-end is-flex-mobile is-justify-content-center">
				{#if !$connected}
					<div class="mr-6">{waiting}</div>
					<button
					class="button is-link is-small py-auto is-justify-content-center m-mobile"
					on:click={async () => {defaultChainStore.setProvider()}}>Connect</button>
				{:else}
					<div class="mr-6-desktop pt-4-mobile truncate is-align-content-center m-mobile m-acc">
						{$selectedAccount}
					</div>
				{/if}
				
			</div>
		</div>
	</nav>

	<div class="container">
		<div class="columns">
			<div class="column is-half is-size-3 mt-5 has-text-centered is-offset-1">
				<div class="is-hidden-mobile">
					Ether Lotto
				</div>
				<div class="card mt-5">
					<div class="card-content">
						<div class="content">
							<h2>Jackpot</h2>
							{#if $selectedAccount == undefined}
								<br>
								<h4>{waiting}</h4>
							{:else}
								{#await jackpot}
									<h3>Waiting for Connection...</h3>
								{:then jackpot}
									<h3>{jackpot} ETH {jackpot*100} LTT</h3>
									<button
										class="button is-primary is-success"
										on:click={playLotto}>Play Lotto</button>
								{/await}
							{/if}
							<br /><br />
							<p>Minimum amount is 0.1 ETH</p>
						</div>
					</div>
				</div>
			</div>

			<div class="column is-one-third has-text-centered is-offset-1 mt-5">
				<div class="card mt-5">
					<div class="card-content">
						<div class="content">
							<h2>Lottery Number</h2>
							{#if $selectedAccount == undefined}
								<br>
								<h4>{waiting}</h4>
							{:else}
								{#await gameNo then gameNo}
									<h3>{gameNo}</h3>
								{/await}
							{/if}
						</div>
					</div>
				</div>

				<div class="card mt-5">
					<div class="card-content">
						<div class="content ">
							<h2>Players in current Lottery<br /></h2>
							{#if $selectedAccount == undefined}
								<br>
								<h4>{waiting}</h4>
							{:else}
								{#await players then players}
									{#if players.length == 0}
										None so far<br /><br />
									{/if}
									{#each players as player}
										<p transition:fade>{player}</p>
									{/each}
								{/await}
							{/if}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container">
		<div class="columns">
			<div class="column is-one-third has-text-centered is-offset-8">
				<div class="card mt-5">
					<div class="card-content">
						<div class="content">
							<h2>Past Winners</h2>
							
							{#if $selectedAccount == undefined}
								<br>
								<h4>{waiting}</h4>
							{:else}
								{#await winners then winners}
									{#if winners.length == 0}
										<br />
										None so far
									{/if}

									{#each winners.slice(0, currentItems) as winners}
										<br />
										<div class="list-element">
											<p transition:fade>
												{winners.returnValues[0]}
												{$web3.utils.fromWei(
													winners.returnValues[1],
													"ether"
												)}ETH
											</p>
										</div>
									{/each}
										<br />
									{#if currentItems < winners.length}
										<button
											class="button"
											on:click={() =>
												(currentItems = currentItems + 5)}
										>
											Show more
										</button>
									{/if}
								{/await}
							{/if}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</main>

<footer class="footer pb-1 mb-3">
	<div class="content">
		<p>
			<strong>Ether Lotto</strong>
			
			{#if owner == $selectedAccount}
				<button class="is-link is-small ml-3" on:click={getWinner}>Get the Winner</button>
				<button class="is-link is-small ml-1" on:click={payWinner}>Pay the Winner</button>
			{/if}
		</p>
	</div>
</footer>

<style>
	main {
		min-height: 90vh;
	}
	
	.card {
		font-size: small;
		/* overflow-wrap: break-word; */
	}

	p {
		font-size: small;
		/* overflow-wrap: break-word; */
		white-space: pre-line;
  		overflow: hidden;
  		text-overflow: ellipsis;
	}
	@media screen and (max-width: 768px) {
		.m-mobile {
			margin-bottom: 5%
		}
		.m-acc{
			padding-left: 12%;
			padding-right: 12%;
		}
		}
		.card {
			margin-left: 4%;
			margin-right: 4%;
		}
		.truncate{
		white-space: nowrap;
  		overflow: hidden;
  		text-overflow: ellipsis;
	}

</style>
